import EnrolmentsAdapter from './base';

export default class Schema extends EnrolmentsAdapter {
  namespace = 'enrolments/v4/templates';
  modelNamePlural = 'schemas';
}
